import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/user/operator`;

export default {
  options(payload) {
    payload.order = "firstName";
    payload.sort = "asc";
    return Client.get(`${resource}/option-call`, {
      params: payload,
    });
  },
};
